import { Address, getContract, PublicClient, WalletClient } from 'viem';

import transparency from '../abis/Transparency';

export const getTransparency = ({
  address,
  publicClient,
  walletClient,
}: {
  publicClient: PublicClient;
  walletClient?: WalletClient;
  address: Address;
}) => {
  return getContract({
    abi: transparency,
    address,
    client: {
      public: publicClient,
      wallet: walletClient,
    },
  });
};
